/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventActionModel } from './EventActionModel';
import {
    EventActionModelFromJSON,
    EventActionModelFromJSONTyped,
    EventActionModelToJSON,
} from './EventActionModel';

/**
 * 
 * @export
 * @interface EventModel
 */
export interface EventModel {
    /**
     * 
     * @type {EventActionModel}
     * @memberof EventModel
     */
    click?: EventActionModel;
    /**
     * 
     * @type {EventActionModel}
     * @memberof EventModel
     */
    add?: EventActionModel;
    /**
     * 
     * @type {EventActionModel}
     * @memberof EventModel
     */
    remove?: EventActionModel;
    /**
     * 
     * @type {EventActionModel}
     * @memberof EventModel
     */
    error?: EventActionModel;
}

/**
 * Check if a given object implements the EventModel interface.
 */
export function instanceOfEventModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventModelFromJSON(json: any): EventModel {
    return EventModelFromJSONTyped(json, false);
}

export function EventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'click': !exists(json, 'click') ? undefined : EventActionModelFromJSON(json['click']),
        'add': !exists(json, 'add') ? undefined : EventActionModelFromJSON(json['add']),
        'remove': !exists(json, 'remove') ? undefined : EventActionModelFromJSON(json['remove']),
        'error': !exists(json, 'error') ? undefined : EventActionModelFromJSON(json['error']),
    };
}

export function EventModelToJSON(value?: EventModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'click': EventActionModelToJSON(value.click),
        'add': EventActionModelToJSON(value.add),
        'remove': EventActionModelToJSON(value.remove),
        'error': EventActionModelToJSON(value.error),
    };
}

